//TODO LINK FUNCTIONS TO THE DIRECTIVE
angular.module('CarsSaraBo').directive('posSelector', function() {
	return {
		scope: {
			posSelected:'=map',
			validations:'=valid',
			errorField:'=error'
		},

		link : function(scope){

			scope.$watch('posSelected', function() {
				for(i in scope.posSelected){
					if(scope.posSelected[i].checked==true){
						scope.validations.hasAnySelected = true;
						return;
					}
				}
				scope.validations.hasAnySelected = false;
			},true)

			scope.tooglePointOfSale= function(oid){
				if(!scope.posSelected[oid]){
					scope.posSelected[oid] = {checked:true};
				}else{
					scope.posSelected[oid].checked=!scope.posSelected[oid].checked;
				}
			}

			scope.checkAll = function (select) {
				for(i in scope.posSelected){
					if(!scope.posSelected[i]){
						scope.posSelected[i]={};
					}
					scope.posSelected[i].checked=select;
				}
			}

			scope.updateValidation = function(field){
				if(scope.errorField!=undefined && scope.errorField[field]){
					scope.errorField[field]=null;
				}
			}
		},
		templateUrl: 'assets/pointOfSale/selector.html'
	};
});


//////////////////
// WEBPACK FOOTER
// ./public/app/models/directives/pos_selector_directive.js
// module id = 882
// module chunks = 3